import { get } from 'lodash'

export default function(fields, fileUrl, { type } = {}) {
  return {
    ...fields,
    file: undefined,
    fileUrl,
    section: {
      value: type || get(fields, 'section.value')
    }
  }
}
